package fr.labodoc.healthProfessional.webApp.pages

import fr.labodoc.healthProfessional.webApp.Page
import fr.labodoc.require
import io.kvision.core.Container
import io.kvision.html.*
import io.kvision.panel.SimplePanel

class PrivacyPolicyPage : SimplePanel(
  className = "page-width"
) {
  init {
    id = "page-privacy-policy"
    require("./css/pages/privacy-policy.css")

    div {
      h1 {
        content = """
          Politique de confidentialité
        """.trimIndent()
      }

      div {
        p {
          content = """
            La présente Politique de confidentialité a pour objet de vous fournir des informations importantes sur la manière dont LABODOC recueille, traite et divulgue vos données personnelles indispensables pour vous permettre de bénéficier de nos services, et sur la manière dont vous pouvez exercer vos droits. Elle vise également à répondre aux exigences de la réglementation relative à la protection des données personnelles (Règlement n° 2016/679) entrée en vigueur le 25 mai 2018.
          """.trimIndent()
        }

        p(rich = true) {
          content = """
            Chez LABODOC, nous comprenons l'importance de la confidentialité et de la sécurité de vos Données à caractère personnel. Nous nous engageons à traiter vos données de manière transparente et sécurisée. Si vous avez des questions ou des commentaires relatifs à notre Politique de confidentialité, vous pouvez nous contacter par courriel à l'adresse suivante : <a href="mailto:contact@labodoc.fr">contact@labodoc.fr</a>.
          """.trimIndent()
        }
      }
    }

    div {
      h2 {
        content = """
          Définitions
        """.trimIndent()
      }

      div {
        p(rich = true) {
          content = """
            Les termes utilisés dans la présente Politique de confidentialité (ci-après « Politique ») ont été définis dans le document « Définitions » disponible <a href="${Page.Definitions().url}" target="_blank">ici</a>.
          """.trimIndent()
        }

        p {
          content = """
            En cas de contradiction entre les termes définis dans la présente Politique et les termes du document « Définitions », les termes de la Politique prévalent.
          """.trimIndent()
        }
      }
    }

    div {
      h2 {
        content = """
          Quelles sont vos Données à caractère personnel recueillies ?
        """.trimIndent()
      }

      div {
        h3 {
          content = """
            Données que vous nous communiquez directement
          """.trimIndent()
        }

        div {
          p {
            content = """
              Lors de la création de votre compte Utilisateur avec une Carte de Professionnel de Santé (CPS) ou une Carte de Professionnel de Santé et Formation (CPF) :
            """.trimIndent()
          }

          ul {
            li {
              content = """
                Le numéro de la carte CPS ou CPF
              """.trimIndent()
            }

            li(rich = true) {
              content = """
                Les données liées à la carte sont alors récupérées de l'annuaire santé (ANS) :
              """.trimIndent()

              ul {
                li {
                  content = """
                    Identifiant PP
                  """.trimIndent()
                }

                li {
                  content = """
                    Nom d'exercice
                  """.trimIndent()
                }

                li {
                  content = """
                    Prénom d'exercice
                  """.trimIndent()
                }

                li {
                  content = """
                    Code profession
                  """.trimIndent()
                }

                li {
                  content = """
                    Code catégorie professionnelle
                  """.trimIndent()
                }

                li {
                  content = """
                    Code savoir-faire
                  """.trimIndent()
                }

                li {
                  content = """
                    Code mode d'exercice
                  """.trimIndent()
                }

                li {
                  content = """
                    Lieux d'exercices
                  """.trimIndent()
                }
              }
            }

            li {
              content = """
                Diplôme d'études spécialisées (DES), uniquement pour les titulaires de carte CPF
              """.trimIndent()
            }

            li {
              content = """
                Subdivision d'affectation (CHU), uniquement pour les titulaires de carte CPF
              """.trimIndent()
            }

            li {
              content = """
                La photo de votre carte CPS ou CPF pourra vous être demandée à des fins de contrôle
              """.trimIndent()
            }

            li {
              content = """
                Département d'exercice, uniquement si aucune adresse professionnelle n'est renseignée dans l'annuaire santé (ANS)
              """.trimIndent()
            }

            li {
              content = """
                Adresse email
              """.trimIndent()
            }
          }
        }

        div {
          p {
            content = """
              Lors de la création de votre compte Utilisateur sans carte CPS ou CPF :
            """.trimIndent()
          }

          ul {
            li(rich = true) {
              content = """
                Pour les professionels de santé :
              """.trimIndent()

              ul {
                li {
                  content = """
                    Nom de famille
                  """.trimIndent()
                }

                li {
                  content = """
                    Prénom
                  """.trimIndent()
                }

                li {
                  content = """
                    Adresse email
                  """.trimIndent()
                }

                li {
                  content = """
                    Profession médicale
                  """.trimIndent()
                }

                li {
                  content = """
                    Spécialité médicale
                  """.trimIndent()
                }

                li {
                  content = """
                    Lieu principal d'exercice
                  """.trimIndent()
                }

                li {
                  content = """
                    Service hospitalier dans lequel vous exercez
                  """.trimIndent()
                }

                li {
                  content = """
                    Département d'exercice
                  """.trimIndent()
                }

                li {
                  content = """
                    Ville d'exercice
                  """.trimIndent()
                }

                li {
                  content = """
                    Un document justifiant de votre statut de professionnel de santé en exercice sur le territoire français et attestant de votre lieu d'exercice actuel
                  """.trimIndent()
                }

                li {
                  content = """
                    Numéro de téléphone (uniquement pour vous contacter au moment de votre inscription)
                  """.trimIndent()
                }
              }
            }

            li(rich = true) {
              content = """
                Pour les étudiants en médecine (externe) :
              """.trimIndent()

              ul {
                li {
                  content = """
                    Nom de famille
                  """.trimIndent()
                }

                li {
                  content = """
                    Prénom
                  """.trimIndent()
                }

                li {
                  content = """
                    Adresse email
                  """.trimIndent()
                }

                li {
                  content = """
                    Subdivision d'affectation (CHU)
                  """.trimIndent()
                }

                li {
                  content = """
                    Un document justifiant de votre statut d'étudiant en médecine (externe)
                  """.trimIndent()
                }
              }
            }
          }
        }

        div {
          p {
            content = """
              Lorsque vous remplissez le formulaire de contact pour contacter LABODOC :
            """.trimIndent()
          }

          ul {
            li {
              content = """
                Nom
              """.trimIndent()
            }

            li {
              content = """
                Adresse email
              """.trimIndent()
            }
          }
        }
      }

      div {
        h3 {
          content = """
            Données recueillies lorsque vous utilisez nos services
          """.trimIndent()
        }

        p {
          content = """
            Lorsque vous utilisez nos services, cela génère des données techniques sur les fonctionnalités que vous avez utilisées, la manière dont vous les avez utilisées et les appareils que vous utilisez pour accéder à nos Services. Voir ci-dessous pour plus de détails :
          """.trimIndent()
        }

        ul {
          li(rich = true) {
            content = """
              <b>Informations sur l'utilisation</b> : L'utilisation des Services génère des données sur votre activité sur nos services, notamment la manière dont vous les utilisez (par exemple, quand vous vous êtes connecté, les fonctions que vous avez utilisées, les actions entreprises, les informations qui vous ont été montrées) et vos interactions sur la Plateforme LaboDoc.
            """.trimIndent()
          }

          li(rich = true) {
            content = """
              <b>Information sur l'appareil</b> : Nous recueillons des informations sur le(s) appareil(s) que vous utilisez pour accéder à nos services, y compris des informations matérielles et logicielles telles que l'adresse IP, l'identifiant et le type d'appareil, les paramètres et les caractéristiques de l'application, les pannes de l'application, les identifiants publicitaires (qui sont des numéros générés de manière aléatoire que vous pouvez réinitialiser en allant dans les paramètres de votre appareil), les identifiants associés aux cookies ou à d'autres technologies qui peuvent identifier de manière unique un appareil ou un navigateur.
            """.trimIndent()
          }
        }
      }
    }

    div {
      h2 {
        content = """
          Comment sont utilisées vos Données à caractère personnel ?
        """.trimIndent()
      }

      div {
        p {
          content = """
            Nous procédons aux traitements de vos données personnelles uniquement afin de :
          """.trimIndent()
        }

        table {
          thead {
            tr {
              th {
                content = """
                  Finalités
                """.trimIndent()
              }

              th {
                content = """
                  Base légale
                """.trimIndent()
              }
            }
          }

          tbody {
            tr {
              td {
                content = """
                  Créer votre Compte Utilisateur sur l'Application
                """.trimIndent()
              }

              td {
                content = """
                  Exécution des Conditions Générales d'Utilisation
                """.trimIndent()
              }
            }

            tr {
              td {
                content = """
                  Créer votre profil au sein de l'Application
                """.trimIndent()
              }

              td {
                content = """
                  Exécution des Conditions Générales d'Utilisation
                """.trimIndent()
              }
            }

            tr {
              td {
                content = """
                  Personnalisation des contenus en fonction de votre spécialité
                """.trimIndent()
              }

              td {
                content = """
                  Intérêt légitime de LABODOC
                """.trimIndent()
              }
            }

            tr {
              td {
                content = """
                  Vous adresser des notifications vous informant de la présence de nouveaux Flash infos et/ou d'invitations dans votre messagerie LaboDoc
                """.trimIndent()
              }

              td {
                content = """
                  Intérêt légitime de LABODOC
                """.trimIndent()
              }
            }

            tr {
              td {
                content = """
                  Vous permettre de vous inscrire aux réunions via les formulaires d'inscription en ligne mis à disposition par les organisateurs de ces évènements
                """.trimIndent()
              }

              td {
                content = """
                  Votre consentement
                """.trimIndent()
              }
            }

            tr {
              td {
                content = """
                  Prendre contact avec vous pour avoir vos retours sur l'Application
                """.trimIndent()
              }

              td {
                content = """
                  Intérêt légitime de LABODOC d'améliorer la qualité de l'Application
                """.trimIndent()
              }
            }

            tr {
              td {
                content = """
                  Répondre à un sondage ou une enquête
                """.trimIndent()
              }

              td {
                content = """
                  Votre consentement
                """.trimIndent()
              }
            }

            tr {
              td {
                content = """
                  Répondre à une question ou une demande de contact via le formulaire de contact de l'Application
                """.trimIndent()
              }

              td {
                content = """
                  Votre consentement
                """.trimIndent()
              }
            }
          }
        }
      }
    }

    div {
      h2 {
        content = """
          À qui sont transmises vos Données à caractère personnel ?
        """.trimIndent()
      }

      div {
        p {
          content = """
            Chez LABODOC, nous sommes soucieux du respect de votre vie privée et prenons à cœur la protection des données personnelles que vous nous communiquez. Uniquement les tiers mentionnés ci-dessous ont accès à vos Données à caractère personnel sous le contrôle de LABODOC :
          """.trimIndent()
        }

        ul {
          li {
            content = """
              Membres du personnel de LABODOC en charge de la gestion des utilisateurs ; ils sont tenus de ne pas divulguer les Données à caractère personnel à des tiers sans autorisation et à prendre toutes les mesures pour garantir l'intégrité et la confidentialité des données.
            """.trimIndent()
          }
        }

        div {
          p {
            content = """
              En tout état de cause, LABODOC s'engage à ne pas transférer vos Données à caractère personnel à des tiers qui auraient pour activité ou finalité l'acquisition de nouveaux prospects en vue d'envoi de prospections commerciales. LABODOC ne vend ni ne loue vos Données à caractère personnel. LABODOC n'utilise pas vos Données à caractère personnel à des fins publicitaires. LABODOC pourra toutefois être amenée à devoir communiquer vos Données à caractère personnel pour se conformer à une obligation légale, à la demande d'une autorité administrative ou judiciaire qui en ferait la demande ou pour l'exercice d'un intérêt légitime comme la défense de ses droits.
            """.trimIndent()
          }
        }
      }
    }

    div {
      h2 {
        content = """
          Quels sont vos droits sur vos Données à caractère personnel ?
        """.trimIndent()
      }

      div {
        p {
          content = """
            Nous souhaitons que vous ayez le contrôle de vos informations. Ainsi vous vous rappelons les options et outils suivants qui sont à votre disposition conformément au RGPD et à la loi n° 78-17 du 6 janvier 1978 :
          """.trimIndent()
        }

        ul {
          li(rich = true) {
            content = """
              <b>Droit d'accès</b> (article 15 RGPD) : vous pouvez à tout moment demander l'accès à vos Données à caractère personnel détenues par LABODOC.
            """.trimIndent()
          }

          li(rich = true) {
            content = """
              <b>Droit de rectification</b> (article 16 RGPD) : vous pouvez à tout moment demander la modification de vos Données à caractère personnel détenues par LABODOC.
            """.trimIndent()
          }

          li(rich = true) {
            content = """
              <b>Droit à l'effacement (« droit à l'oubli »)</b> (article 17 du RGPD) : vous pouvez à tout moment demander la suppression de vos Données à caractère personnel détenues par LABODOC.
            """.trimIndent()
          }

          li(rich = true) {
            content = """
              <b>Droit à la limitation du traitement</b> (article 18 du RGPD) : vous disposez du droit de limiter les traitements effectués sur vos Données à caractère personnel uniquement lorsque l'une des situations suivantes se présente :
            """.trimIndent()

            ul {
              li {
                content = """
                  Vous contestez l'exactitude de vos données
                """.trimIndent()
              }

              li {
                content = """
                  Vous pensez que le traitement de vos Données à caractère personnel est illicite
                """.trimIndent()
              }

              li {
                content = """
                  Vous avez besoin de cette limitation pour la constatation, l'exercice ou la défense de vos droits en justice.
                """.trimIndent()
              }
            }
          }

          li(rich = true) {
            content = """
              <b>Droit à la portabilité des données</b> (article 20 RGPD) : vous avez la possibilité de demander à récupérer les Données à caractère personnel que vous avez fournies à LABODOC, pour un usage personnel ou pour les transmettre à un tiers de votre choix.
            """.trimIndent()
          }

          li(rich = true) {
            content = """
              <b>Droit d'opposition</b> (article 21 RGPD) : vous pouvez vous opposer au traitement de vos Données à caractère personnel effectué sur le fondement de l'intérêt légitime de LABODOC.
            """.trimIndent()
          }
        }

        div {
          p(rich = true) {
            content = """
              Vous avez également le droit d'introduire une réclamation auprès d'une autorité de contrôle, et notamment de la CNIL (<a href="https://www.cnil.fr/fr/plaintes" target="_blank">https://www.cnil.fr/fr/plaintes</a>).
            """.trimIndent()
          }
        }

        div {
          p {
            content = """
              Pour plus d'informations ou pour exercer vos droits, vous pouvez contacter LABODOC :
            """.trimIndent()
          }

          ul {
            li {
              content = """
                Par écrit à l'adresse suivante : LABODOC – DPO, 12 Boulevard Carnot, 21000 Dijon.
              """.trimIndent()
            }

            li(rich = true) {
              content = """
                Par mail à l'adresse suivante : <a href="mailto:dpo@labodoc.fr">dpo@labodoc.fr</a>.
              """.trimIndent()
            }
          }

          p {
            content = """
              Dans ce cas, vous devez indiquer les Données à caractère personnel que vous souhaitez que LABODOC corrige, mette à jour ou supprime, en vous identifiant de manière précise avec une copie d'une pièce d'identité (carte d'identité ou passeport) ou tout autre élément permettant de justifier de votre identité.
            """.trimIndent()
          }
        }
      }
    }

    div {
      h2 {
        content = """
          Combien de temps sont conservés vos Données à caractère personnel ?
        """.trimIndent()
      }

      div {
        p {
          content = """
            Chez LABODOC, nous nous engageons à conserver vos Données à caractère personnel uniquement pendant la durée nécessaire aux finalités du traitement et n'excédant pas les durées indiquées ci-dessous :
          """.trimIndent()
        }

        ul {
          li {
            content = """
              Données d'identification de l'Utilisateur : pendant toute la durée de l'utilisation du Compte Utilisateur et jusqu'à sa suppression ou pendant une durée de 2 ans à compter du moment où le compte est inactif. En cas de compte inactif, un email vous sera adressé pour vous demander si vous souhaitez conserver votre compte ou le supprimer.
            """.trimIndent()
          }
        }
      }
    }

    div {
      h2 {
        content = """
          Comment sont protégées vos Données à caractère personnel ?
        """.trimIndent()
      }

      div {
        p {
          content = """
            Chez LABODOC, nous prenons très au sérieux la sécurisation de vos Données à caractère personnel et nous agissons avec précaution pour empêcher qu'elles soient déformées, endommagées, ou que des tiers non autorisés y aient accès. C'est pourquoi nous avons mis en place des mesures administratives, logiques, physiques et de gestion pour garantir autant que possible l'intégrité et la confidentialité. Ces mesures sont conçues pour fournir un niveau de sécurité approprié aux risques liés au traitement de vos Données à caractère personnel.
          """.trimIndent()
        }

        p(rich = true) {
          content = """
            Les données sont hébergées dans les datacenters d'OVH (vous pouvez consulter la politique de sécurité d'OVH <a href="https://www.ovhcloud.com/fr/personal-data-protection/security/" target="_blank">ici</a>). Les données transitent entre votre terminal et les serveurs de LABODOC de manière sécurisée via un certificat SSL. La sécurité de vos Données à caractère personnel est également assurée par la mise en place de procédés d'authentification avec accès personnel et sécurisé via des identifiants et mots de passe confidentiels.
          """.trimIndent()
        }

        p {
          content = """
            Cependant, veuillez noter qu'aucun mode de transmission sur Internet ni aucun mode de stockage électronique n'est sûr et fiable à 100 %, et nous ne pouvons en garantir la sécurité absolue.
          """.trimIndent()
        }
      }
    }

    div {
      h2 {
        content = """
          Comment sont utilisés les Cookies ?
        """.trimIndent()
      }

      div {
        p(rich = true) {
          content = """
            Veuillez-vous référer à notre <a href="${Page.CookiesPolicy().url}" target="_blank">Politique de cookies</a>.
          """.trimIndent()
        }
      }
    }
  }
}

fun Container.privacyPolicyPage(): PrivacyPolicyPage {
  val privacyPolicyPage = PrivacyPolicyPage()

  this.add(privacyPolicyPage)
  return privacyPolicyPage
}
